import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-[8px] border border-gray-200 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600 data-[state=checked]:text-white hover:border-red-600 transition-colors",
      // Add checkbox-specific class to prevent mobile height override
      // (NOTE: no CSS rule for `.checkbox-component` exists anywhere in the app — kept
      // only because call sites/tests may select on it. Nothing here relies on it.)
      "checkbox-component",
      // 20px painted box = a 20px touch target, well under the 44pt minimum, and this is
      // the single most-tapped control in the app (checklists). Grow the HIT AREA with a
      // transparent pseudo-element instead of the box: 20 + 2*12 = 44. Mobile-only, so on
      // desktop the halo can't swallow clicks/text-selection next to the checkbox.
      "max-[937px]:relative max-[937px]:after:absolute max-[937px]:after:inset-x-[-12px] max-[937px]:after:inset-y-[-12px] max-[937px]:after:content-['']",
      className
    )}
    role="checkbox"
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-5 w-5" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
